import { render, staticRenderFns } from "./VxCellCredentialsExtraPoints.vue?vue&type=template&id=fe7a81e6&"
import script from "./VxCellCredentialsExtraPoints.vue?vue&type=script&lang=js&"
export * from "./VxCellCredentialsExtraPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports